export enum TermStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export type EnrollmentStatus = 'FULL_TIME' | 'PART_TIME';
